module.exports = __webpack_public_path__ + "site/img/76.bf865e3d.jpg";